'use client';

export const clientLogger = {
  info: (message: string, context?: unknown) => {
    if (context === undefined) {
      console.info(message);
      return;
    }
    console.info(message, context);
  },
  warn: (message: string, context?: unknown) => {
    if (context === undefined) {
      console.warn(message);
      return;
    }
    console.warn(message, context);
  },
  error: (message: string, error?: unknown) => {
    if (error === undefined) {
      console.error(message);
      return;
    }
    console.error(message, error);
  },
};
